import React, { useEffect, useState } from 'react'
import Wysiwyg from '../../../../components/elements/form/Wysiwyg'
import TextField from '../../../../components/elements/form/TextField'
import FormButton from '../../../../components/elements/form/FormButton'
import { useDispatch, useSelector } from 'react-redux'
import { CREATING_DOCUMENT, ERROR, SET_SUCCESS } from '../../../../store/types'
import { clearCreatedDocument, createDocument } from '../../../../store/actions/documentActions'
import CopyToClipboard from 'react-copy-to-clipboard'
import CopyIcon from '../../../../components/elements/icons/CopyIcon'
import { useNavigate } from 'react-router-dom'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'
import { Switch } from '@headlessui/react'
import FileUpload from '../../../../components/elements/form/FileUpload'
import { authHeader } from '../../../../utils'

const NewDocument = () => {
    const navigate = useNavigate()
    const [validationErrors, setValidationErrors] = useState({});
    const [documentPayload, setDocumentPayload] = useState({});
    
    const dispatch = useDispatch()
    const documentsSelector = useSelector(state => state.documents)

    useEffect(() => {
      if(documentsSelector.createdDocument !== null){
        dispatch({
          type: SET_SUCCESS,
          payload: "Document created successfully"
        })
        dispatch(clearCreatedDocument())
        setDocumentPayload({})
        navigate('/admin/administration/documents')
      }
      return () => {
        
      };
    }, [dispatch, navigate, documentsSelector.createdDocument]);


    const validateForm = () => {
      let errors = {}
      if (!documentPayload.name || documentPayload.name === '') {
        errors.name = true
      }
      if (!documentPayload.description || documentPayload.description === '') {
        errors.description = true
      }
      if (!documentPayload.documentBody || documentPayload.documentBody === '') {
        errors.documentBody = true
      }

      if(requiresHeaderImage && !file) {
        errors.file = true
      }

      setValidationErrors(errors)
      return errors
    }

    const triggerCreateDocument = async () => {
      if (Object.values(validateForm()).includes(true)) {
        dispatch({
          type: ERROR,
          error: {response: {data: {
              message: 'Please check the highlighted fields'
          }}}
        });
        return
      }

      const payload = {...documentPayload}

      if(file) {
        const uploaded = await handleUpload(file) 
        payload.documentHeaderImage = uploaded.data.file
      }

      dispatch(createDocument(payload))
    }

    const documentVariables = [
      {
        value: '[[firstName]]',
        description: 'Copy and paste this to insert assignee first name'
      },
      {
        value: '[[otherNames]]',
        description: 'Copy and paste this to insert assignee other names'
      },
      {
        value: '[[lastName]]',
        description: 'Copy and paste this to insert assignee last name'
      },
      {
        value: '[[parent.firstName]]',
        description: `Copy and paste this to insert the first name of the assignee's primary parent`
      },
      {
        value: '[[parent.otherNames]]',
        description: `Copy and paste this to insert other names of the assignee's primary parent`
      },
      {
        value: '[[parent.lastName]]',
        description: `Copy and paste this to insert last name of the assignee's primary parent`
      },
      {
        value: '[[email]]',
        description: 'Copy and paste this to insert assignee email address'
      },
      {
        value: '[[phone]]',
        description: 'Copy and paste this to insert assignee phone number'
      },
      {
        value: '[[parent.email]]',
        description: `Copy and paste this to insert email address of the assignee's primary parent`
      },
      {
        value: '[[parent.phone]]',
        description: `Copy and paste this to insert phone number of the assignee's primary parent`
      },
      {
        value: '[[dateOfBirth]]',
        description: 'Copy and paste this to insert assignee date of birth'
      },
      {
        value: '[[startDate]]',
        description: 'Copy and paste this to insert employee start date'
      },
      {
        value: '[[address]]',
        description: 'Copy and paste this to insert assignee address'
      },
      {
        value: '[[parent.address]]',
        description: `Copy and paste this to insert address of the assignee's primary parent`
      },
      {
        value: '[[admissionNumber]]',
        description: 'Copy and paste this to insert assignee address'
      },
      {
        value: '[[employeeCode]]',
        description: 'Copy and paste this to insert assignee address'
      },
      {
        value: '[[applicationCode]]',
        description: 'Copy and paste this to insert assignee address'
      },
      // {
      //   value: '[[feeAmount]]',
      //   description: 'Copy and paste this to insert fee amount'
      // },
    ]

    const [requiresHeaderImage, setRequiresHeaderImage] = useState(false);
    const [file, setFile] = useState(null);
    
    const handleUpload = async (file) => {
      console.log(file)
      var formData = new FormData()
      formData.append('file', file.file )
      const headers = new Headers();
      headers.append("Authorization",  authHeader().Authorization);
      try {
        dispatch({
          type: CREATING_DOCUMENT,
          payload: true
        })
        const doUpload = await fetch(`${process.env.REACT_APP_BASE_URL}/files/new`, {
          method: "POST",
          headers,
          body: formData,
        });
        const response = await doUpload.json();

        return response
      } catch (error) {
        dispatch({
            type: ERROR,
            error,
        });
      }
    }
    
    return (
      <>
        <AdministrationLayout pageTitle={`New document`}>
          <div className=''>
            <div className='w-full lg:flex flex-row gap-x-8'>
              <div className='w-full lg:w-10/12 pb-6 mx-auto px-12'>
                <div className='flex justify-between items-center mt-4 mb-4'>
                  <h3 className='font-medium text-lg'>Create a new document </h3>
                </div>

                <div className='w-full'>
                  <div className='flex items-center justify-between gap-x-8 px-6'>
                      <div className='w-4/12'>
                          <div className='mb-8 w-full'>
                              <TextField
                                  inputLabel="Document name" 
                                  fieldId="document-name" 
                                  inputType="text" 
                                  preloadValue={''}
                                  hasError={validationErrors.name} 
                                  returnFieldValue={(value)=>{setDocumentPayload({...documentPayload, ...{name: value}})}}
                              />
                          </div>          
                      </div>
                      <div className='w-8/12'>
                          <div className='mb-8 w-full'>
                              <TextField
                                  inputLabel="Description" 
                                  fieldId="document-description" 
                                  inputType="text" 
                                  preloadValue={''}
                                  hasError={validationErrors.description} 
                                  returnFieldValue={(value)=>{setDocumentPayload({...documentPayload, ...{description: value}})}}
                              />
                          </div>                
                      </div>
                  </div>

                  <div className="w-full flex justify-between gap-x-4 mt-4 border-secondary border-opacity-50 px-6 mb-8">
                      <div className='w-10/12'>
                          <label className="block text-sm font-medium text-gray-700 font-sofia-pro">Set a header image (letterhead)</label>
                          <p className="text-xs text-gray-500 font-sofia-pro">The header image, if selected will be embedded at the top of the document, any time it is generated and sent or read. This will typically be the leader for an official letterhead.</p>
                      </div>
                      <div className='w-2/12 flex flex-row-reverse'>
                          <Switch
                              checked={requiresHeaderImage}
                              onChange={()=>{setRequiresHeaderImage(!requiresHeaderImage)}}
                              className={`${
                                  requiresHeaderImage ? 'bg-accent' : 'bg-gray-400'
                              } relative inline-flex items-center h-5 rounded-full w-10`}
                              >
                              <span className="sr-only">Requires header image</span>
                              <span
                                  className={`transform transition ease-in-out duration-200 ${
                                      requiresHeaderImage ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                                  } inline-block w-3 h-3 transform rounded-full`}
                              />
                          </Switch>
                      </div>
                  </div>
                  {requiresHeaderImage && <div className='mt-2 w-full px-6 mb-8'>
                    <FileUpload
                          hasError={validationErrors.file}
                          fieldLabel={`Header Image`}
                          returnFileDetails={(details)=>{
                              setFile(details)
                          }}
                          acceptedFormats={['png', 'jpeg', 'jpg']}
                      />
                      <label className='block mt-3 text-xs text-gray-400'>{`The image to be displayed on the header of the document, for best results, please use images with a minimum width of 2,480px and a maximum height of 300px`}</label>
                  </div>}

                  <div className='px-6'>
                    <div className='w-full pt-4 pb-4 flex gap-x-4 items-start justify-between'>
                      <div  className='w-full'>
                        <p className="text-sm font-[500] text-gray-600">
                            Requires Expiry Date
                        </p>
                        <p className='text-xs text-gray-700 mt-2'>Will the provider of this document be required to provide an expiry date for it?</p>
                      </div>
                      <div className='w-24 flex flex-row-reverse pt-2'>
                        <Switch
                          checked={documentPayload.requiresExpiry}
                          onChange={()=>{setDocumentPayload({...documentPayload, ...{requiresExpiry: !documentPayload.requiresExpiry}})}}
                          className={`${
                              documentPayload.requiresExpiry ? 'bg-accent' : 'bg-gray-400'
                          } relative inline-flex items-center h-5 rounded-full w-10`}
                          >
                          {/* <span className="sr-only">Display stock levels</span> */}
                          <span
                              className={`transform transition ease-in-out duration-200 ${
                              documentPayload.requiresExpiry ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                              } inline-block w-3 h-3 transform rounded-full`}
                          />
                        </Switch>
                      </div>
                    </div>

                    <div className='w-full pt-4 pb-4 flex gap-x-4 items-start justify-between'>
                      <div className='w-full'>
                        <p className="text-sm font-[500] text-gray-600">
                            Requires Document Number
                        </p>
                        <p className='text-xs text-gray-700 mt-2'>Will the provider of this document be required to provide a document number?</p>
                      </div>
                      <div className='w-24 flex flex-row-reverse pt-2'>
                        <Switch
                          checked={documentPayload.requiresDocumentNumber}
                          onChange={()=>{setDocumentPayload({...documentPayload, ...{requiresDocumentNumber: !documentPayload.requiresDocumentNumber}})}}
                          className={`${
                              documentPayload.requiresDocumentNumber ? 'bg-accent' : 'bg-gray-400'
                          } relative inline-flex items-center h-5 rounded-full w-10`}
                          >
                          {/* <span className="sr-only">Display stock levels</span> */}
                          <span
                              className={`transform transition ease-in-out duration-200 ${
                              documentPayload.requiresDocumentNumber ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                              } inline-block w-3 h-3 transform rounded-full`}
                          />
                        </Switch>
                      </div>
                    </div>            

                    <div className='w-full pt-4 pb-6 flex gap-x-4 items-start justify-between'>
                      <div className='w-full'>
                        <p className="text-sm font-[500] text-gray-600">
                            Requires signing
                        </p>
                        <p className='text-xs text-gray-700 mt-2'>Flip this toggle if the receiver of this document is required to sign it</p>
                      </div>
                      <div className='w-24 flex flex-row-reverse pt-2'>
                        <Switch
                          checked={documentPayload.requiresSigning}
                          onChange={()=>{setDocumentPayload({...documentPayload, ...{requiresSigning: !documentPayload.requiresSigning}})}}
                          className={`${
                              documentPayload.requiresSigning ? 'bg-accent' : 'bg-gray-400'
                          } relative inline-flex items-center h-5 rounded-full w-10`}
                          >
                          {/* <span className="sr-only">Display stock levels</span> */}
                          <span
                              className={`transform transition ease-in-out duration-200 ${
                              documentPayload.requiresSigning ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                              } inline-block w-3 h-3 transform rounded-full`}
                          />
                        </Switch>
                      </div>
                    </div>
                  </div>
                  
                  <div className='w-full px-6 pb-6'>
                      <label 
                      className={`font-montserrat cursor-text bg-transparent text-sm z-10 font-outfit font-medium transition duration-200  
                      text-gray-500`}>
                          Document variables
                      </label>
                      <label className='text-xs block mt-2'>Document variables are placeholders for live employee data. The following list describes the useable variables. Just copy and paste them at the position where you want them replaced in the document if they are available for the document assignee</label>

                      {documentVariables.map((variable, variableIndex) => (
                        <div key={variableIndex} className='flex items-center gap-x-1'>
                          <CopyToClipboard text={variable.value}
                            onCopy={() =>  dispatch({
                                type: SET_SUCCESS,
                                payload:  `${variable.value} copied to clipboard`
                            })}>
                            <button className='pt-1'><CopyIcon className={`w-5 h-5 text-gray-500`}/></button>
                          </CopyToClipboard>
                          <p className='text-xs my-4'><span className='p-1 bg-gray-200 items-center gap-x-1 inline'>
                          {variable.value}</span> : {variable.description}
                          </p>
                        </div>
                      ))}
                  </div>
                  
                  <div className='w-full px-6 pb-4'>
                      <label 
                      className={`font-montserrat cursor-text bg-transparent text-sm z-10 font-outfit font-medium transition duration-200  
                      ${validationErrors.documentBody ? 'text-red-600' : 'text-gray-500'}`}>
                          Document body
                      </label>
                      <label className='text-xs block mt-2'>Paste and format (or type in the contents of your document) in the editor below</label>
                  </div>

                  <div className='w-full'>
                    <div className='borderless px-6 long-text'>
                        <Wysiwyg 
                          fieldTitle=""
                          initialValue={''}
                          updateValue={(value)=>{setDocumentPayload({...documentPayload, ...{documentBody: value}})}}
                        />
                    </div>
                  </div>

                  <div className='my-8 flex flex-row-reverse items-center justify-between'>
                      <div className='w-3/12'>
                      <FormButton buttonLabel={`Save document`} buttonAction={()=>{triggerCreateDocument()}} processing={documentsSelector.creatingDocument} />
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </AdministrationLayout>
      </>
    )
}

export default NewDocument